import cloneDeep from 'lodash/cloneDeep';

import Account from 'redpoints-model-js/model/account/Account';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';

import {
  INCIDENT_DETAILS_CLEAR,
  INCIDENT_DETAILS_FETCH_INCIDENT_DATA_SUCCESS,
  INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_REQUEST,
  INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_SUCCESS,
  INCIDENT_DETAILS_SET_DETECTION_LINK_MODIFIED_ACCOUNT,
} from '../../../../actions/actionTypes';

const defaultState = null;

const detectionLinkAccount = (state = defaultState, action) => {
  switch (action.type) {
    case INCIDENT_DETAILS_FETCH_INCIDENT_DATA_SUCCESS: {
      const account =
        action.payload.response.data.detectionLink?.account ?? null;

      return cloneDeep(account);
    }

    case INCIDENT_DETAILS_SET_DETECTION_LINK_MODIFIED_ACCOUNT: {
      return cloneDeep(action.payload.account);
    }

    case INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_SUCCESS: {
      const account = cloneDeep(action.payload.response.data);

      if (action.payload.response.status === HttpStatus.CONFLICT.value) {
        return new Account();
      }

      return Object.assign(new Account(), account, {
        url: action.payload.searchUrl,
        identifier: action.payload.searchIdentifier,
      });
    }

    case INCIDENT_DETAILS_CLEAR:
    case INCIDENT_DETAILS_SEARCH_DETECTION_LINK_ACCOUNT_REQUEST:
      return defaultState;

    default:
      return state;
  }
};

export default detectionLinkAccount;
